"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _headingModule = _interopRequireDefault(require("./heading.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading = function Heading(props) {
  var id = props.id,
      title = props.title,
      variant = props.variant,
      _props$headingTestId = props.headingTestId,
      headingTestId = _props$headingTestId === void 0 ? 'headingTestID' : _props$headingTestId;

  if (variant === "h1") {
    return _react.default.createElement("h1", {
      id: id ? id : null,
      className: (0, _classnames.default)(_themeModule.default.arag, _headingModule.default["heading-1"]),
      "data-testid": headingTestId
    }, title);
  }

  if (variant === "h2") {
    return _react.default.createElement("h2", {
      id: id ? id : null,
      className: (0, _classnames.default)(_themeModule.default.arag, _headingModule.default["heading-2"]),
      "data-testid": headingTestId
    }, title);
  }

  if (variant === "h3") {
    return _react.default.createElement("h3", {
      id: id ? id : null,
      className: (0, _classnames.default)(_themeModule.default.arag, _headingModule.default["heading-3"]),
      "data-testid": headingTestId
    }, title);
  }

  if (variant === "h4") {
    return _react.default.createElement("h1", {
      id: id ? id : null,
      className: (0, _classnames.default)(_themeModule.default.arag, _headingModule.default["heading-4"]),
      "data-testid": headingTestId
    }, title);
  }

  return _react.default.createElement("h1", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _headingModule.default["heading-1"]),
    "data-testid": headingTestId
  }, title);
};

Heading.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** The variant of the Heading. Matches to native heading elements. eg: h1 */
  variant: _propTypes.default.oneOf(["h1", "h2", "h3", "h4"]),

  /** String text */
  title: _propTypes.default.string.isRequired,

  /** Test ID for heading*/
  headingTestId: _propTypes.default.string
};
var _default = Heading;
exports.default = _default;